import { Box, Container, Typography, Link } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Box sx={{ py: 6, backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <Container maxWidth="md">
        <Typography variant="h4" gutterBottom fontWeight={700}>
          MyFreshTools - Privacy Policy and Terms
        </Typography>

        <Typography variant="body1" paragraph>
          Your privacy is important to us. It is MyFreshTools policy to respect your privacy regarding any information we may collect from you across our website ("Services"), and other sites we own and operate.
        </Typography>

        <Typography variant="body1" paragraph>
          We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used.
        </Typography>

        <Typography variant="body1" paragraph>
          We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we’ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.
        </Typography>

        <Typography variant="body1" paragraph>
          We don’t share any personally identifying information publicly or with third-parties, except when required to by law.
        </Typography>

        <Typography variant="body1" paragraph>
          Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.
        </Typography>

        <Typography variant="body1" paragraph>
          MyFreshTools uses YouTube API Services, and by using YouTube Content within MyFreshTools Sites and Services you are agreeing to be bound to&nbsp;
          <Link href="https://www.youtube.com/t/terms" target="_blank" rel="noopener" underline="hover">
            YouTube’s Terms of Service
          </Link>{" "}
          and&nbsp;
          <Link href="https://policies.google.com/privacy" target="_blank" rel="noopener" underline="hover">
            Google’s Privacy Policy
          </Link>.
        </Typography>

        <Typography variant="body1" paragraph>
          Third-party social networking services, such as Google and YouTube, may update their Terms of Service and Privacy Policies from time to time, and MyFreshTools is not responsible for your review of any changes or updates to these. We recommend that you review YouTube’s Terms of Service and Google’s Privacy Policy regularly.
        </Typography>

        <Typography variant="body1" paragraph>
          The Service also might enable linking between various online third-party services, including YouTube (“Third-Party Services”). To take advantage of these features and capabilities, we may ask you to authenticate, register for or log into Third-Party Services through the Service or on the websites of their respective providers and, if applicable, allow you to configure your privacy settings in that third-party website account to permit your activities on the Service to be shared with your contacts in your third-party site account.
        </Typography>

        <Typography variant="body1" paragraph>
          You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.
        </Typography>

        <Typography variant="body1" paragraph>
          Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information. If you have any questions about how we handle user data and personal information, feel free to&nbsp;
          <Link href="/contact" underline="hover">
            contact us
          </Link>.
        </Typography>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;